<div class="topdiv">
  <div class="row topRowMargins headerStyle" style="margin-top: 0">
    <div style="margin-left: 15px">
      <label class="textColour">Filters List</label>
    </div>
  </div>

  <div>
    <form novalidate [formGroup]="validations_form">
      <div class="row">
        <div class="col-lg-3" style="text-align: end">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSTAFFMASTERfirstname">Filter Name</mat-label>
            <input
              matInput
              type="text"
              placeholder="Filter Name"
              formControlName="filtername"
              [(ngModel)]="dataSetObject.filtername"
              maxlength="100"
              required
            />
            <mat-error
              *ngFor="let validation of validation_messages.filtername"
            >
              <span
                *ngIf="
                  validations_form
                    .get('filtername')
                    .hasError(validation.type) &&
                  (validations_form.get('filtername').dirty ||
                    validations_form.get('filtername').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSTAFFMASTERfirstname"
              >Filter Description</mat-label
            >
            <input
              style="width: 150px"
              matInput
              type="text"
              placeholder="Filter Description"
              formControlName="filterdescription"
              [(ngModel)]="dataSetObject.filterDescription"
              maxlength="100"
              required
            />
            <mat-error
              *ngFor="let validation of validation_messages.filterdescription"
            >
              <span
                *ngIf="
                  validations_form
                    .get('filterdescription')
                    .hasError(validation.type) &&
                  (validations_form.get('filterdescription').dirty ||
                    validations_form.get('filterdescription').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
              >Select Dataset</mat-label
            >
            <input
              matInput
              type="text"
              (click)="userMultiDropdown()"
              [(ngModel)]="dataSetObject.datasetName"
              formControlName="selectdataSet"
              readonly
              required
            />
            <mat-error
              *ngFor="let validation of validation_messages.selectdataSet"
            >
              <span
                *ngIf="
                  validations_form
                    .get('selectdataSet')
                    .hasError(validation.type) &&
                  (validations_form.get('selectdataSet').dirty ||
                    validations_form.get('selectdataSet').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
              >Select Aggregates</mat-label
            >
            <mat-select
              [(ngModel)]="selectedAggregates"
              multiple
              formControlName="selectAggregate"
              (selectionChange)="onAggregateChange($event)"
            >
              <mat-option
                *ngFor="let field of aggregateData"
                [value]="field.alias"
              >
                {{ field.alias }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div
        class="row"
        style="margin-top: 22px"
        [ngStyle]="{
          'margin-bottom': uploadExternalFileChecked ? '35px' : '0px',
        }"
      >
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
              >Select Report Visual</mat-label
            >
            <mat-select
              [(ngModel)]="selectedVisual"
              formControlName="selectVisual"
              (selectionChange)="onVisualSelectionChanged($event)"
            >
              <mat-option>None</mat-option>
              <mat-option
                *ngFor="let field of visualData"
                [value]="field.visualId"
              >
                {{ field.visualName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
              >Select Pivot Aggregates</mat-label
            >
            <mat-select
              [(ngModel)]="selectedPivotAggregates"
              multiple
              formControlName="selectPivotAggregate"
              (selectionChange)="onPivotAggregateChange($event)"
            >
              <ng-container *ngFor="let field of pivotAggregateData">
                <ng-container
                  *ngIf="field.pivotMetadata?.length > 0; else noPivot"
                >
                  <mat-option
                    *ngFor="let meta of field.pivotMetadata"
                    [value]="meta.totalAlias"
                  >
                    {{ meta.totalAlias }}
                  </mat-option>
                </ng-container>

                <ng-template #noPivot>
                  <mat-option [value]="field.totalAlias">
                    {{ field.totalAlias }}
                  </mat-option>
                </ng-template>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- Added new dropdown to select sorting data
        Added by Aman Singh
        Date: 03 November 2025 -->

        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMclassifiedserviceType"
              >Select Sorting</mat-label
            >
            <mat-select
              [(ngModel)]="selectedSorting"
              multiple
              formControlName="selectSorting"
              (selectionChange)="onSortingchnage($event)"
            >
              <mat-option
                *ngFor="let field of sortingData"
                [value]="field.orderKeyAlias"
              >
                {{ field.orderKeyAlias }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-3" style="margin: auto">
          <mat-checkbox
            class="example-margin"
            [(ngModel)]="checked"
            formControlName="setAsDefaultFilter"
            (change)="onDefaultFilterChange()"
            >Default Filter
          </mat-checkbox>
        </div>
        <div class="col-lg-3" style="margin: auto"></div>
        <div class="col-lg-3" style="margin: auto"></div>
        <div class="col-lg-3" style="margin: auto"></div>
        <div class="col-lg-3" style="margin: auto">
          <mat-checkbox
            class="example-margin"
            [(ngModel)]="uploadExternalFileChecked"
            formControlName="uploadExternalFile"
            (change)="onuploadExternalFileChange()"
            >Upload File</mat-checkbox
          >
        </div>
        <div class="col-lg-3" style="margin: auto">
          <mat-form-field
            appearance="outline"
            *ngIf="uploadExternalFileChecked"
          >
            <mat-label i18n="@@RCEnterValue">Select Object</mat-label>
            <!-- <input matInput type="text" maxlength="200" formControlName="s3Path"
              [(ngModel)]="dataSetObject.s3Path"> -->
            <mat-select
              [(ngModel)]="dataSetObject.s3Path"
              formControlName="s3Path"
              [title]="dataSetObject.s3Path ? dataSetObject.s3Path : ''"
            >
              <mat-option>None</mat-option>
              <mat-option
                *ngFor="let object of objectMetadata"
                [value]="object.objectname"
              >
                {{ object.objectname }}
              </mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.s3Path">
              <span
                *ngIf="
                  validations_form.get('s3Path').hasError(validation.type) &&
                  (validations_form.get('s3Path').dirty ||
                    validations_form.get('s3Path').touched)
                "
              >
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-3" style="margin: auto"></div>
        <div class="col-lg-3" style="margin: auto"></div>
      </div>
    </form>
  </div>

  <div *ngIf="!uploadExternalFileChecked">
    <div style="margin-bottom: 0">
      <div class="row" class="row topRowMargins headerStyle">
        <div style="margin-bottom: 1rem">
          <div style="height: 7vh; margin-left: 15px">
            <label class="textColour"
              >Filters <em style="font-size: 0.7em" class="fas fa-filter"></em
            ></label>
          </div>
        </div>
      </div>

      <div class="container">
        <div
          class="row"
          *ngIf="showFilter"
          style="margin-top: -30px; margin-bottom: 30px"
        >
          <div class="table-responsive">
            <table class="table">
              <caption></caption>
              <thead class="table-heading">
                <!-- style="position: sticky;z-index: 2;top: 0; max-height: 150px;overflow-y: auto;" -->
                <tr>
                  <th class="th-lg text-left">Label</th>
                  <th class="th-lg text-left">Object</th>
                  <th class="th-lg text-left">Attribute</th>
                  <th class="th-lg text-left">Condition</th>
                  <th class="th-lg text-left">Value</th>
                  <th class="th-lg text-left" *ngIf="between">Value1</th>
                  <th class="th-lg text-left">Null Options</th>
                  <th class="th-lg text-left">Priority</th>
                  <th class="th-lg text-left">Hide Filter</th>
                  <th class="th-lg text-left">Mandatory</th>
                  <th class="th-lg text-left">Show In Quicksight Visuals</th>
                  <th class="th-lg text-left">Display Calculated Fields In</th>
                  <th
                    class="th-lg text-left"
                    style="text-align: end; padding-right: 33px"
                  >
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody
                style="border: none"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
              >
                <tr *ngFor="let whereData of where; let k = index" cdkDrag>
                  <td class="conditionsalign text-left">
                    {{ whereData.label }}
                  </td>
                  <td class="conditionsalign text-left">
                    {{ whereData.objectWhere }}
                  </td>
                  <td class="conditionsalign text-left">
                    {{ whereData.whereKey }}
                  </td>
                  <td class="conditionsalign text-left">
                    {{ whereData.whereCondition }}
                  </td>
                  <td class="conditionsalign text-left">
                    {{ whereData.whereValue }}
                  </td>
                  <td class="conditionsalign text-left" *ngIf="between">
                    {{ whereData.whereValue1 }}
                  </td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.excludeNull">Exclude Nulls</span>
                    <span *ngIf="whereData.showOnlyNulls">Show Only Nulls</span>
                  </td>
                  <td class="conditionsalign text-left">
                    <span>{{ whereData.priority }}</span>
                  </td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.hideInVisuals">Yes</span>
                    <span *ngIf="!whereData.hideInVisuals">No</span>
                  </td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.mandatoryFilter">Yes</span>
                    <span *ngIf="!whereData.mandatoryFilter">No</span>
                  </td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.showInQuicksightVisuals">Yes</span>
                    <span *ngIf="!whereData.showInQuicksightVisuals">No</span>
                  </td>
                  <td class="conditionsalign text-left">
                    <span *ngIf="whereData.showInQuicksightVisuals">{{
                      whereData.displayCalculatedFieldsIn
                    }}</span>
                  </td>
                  <td
                    class="conditionsalign text-left"
                    style="text-align: end; padding-right: 33px"
                  >
                    <label class="CloseButtonStyle">
                      <span
                        ><em
                          (click)="deleteWhere(k)"
                          class="fas fa-minus"
                          style="color: white"
                          title="Remove Filter"
                        ></em
                      ></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <form novalidate [formGroup]="formValidWhere">
        <div>
          <div class="row topRowMargins" style="margin-top: -25px">
            <div class="col-lg-4 filterCol">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCEnterValue">Label</mat-label>
                <input
                  matInput
                  type="text"
                  maxlength="50"
                  formControlName="label"
                  [(ngModel)]="whereData.label"
                  [title]="whereData.label ? whereData.label : ''"
                />
              </mat-form-field>
            </div>
            <div class="col-lg-4 filterCol">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCFields">Objects</mat-label>
                <mat-select
                  [(ngModel)]="whereData.objectWhere"
                  (selectionChange)="whereKey($event)"
                  formControlName="objectWhere"
                  [title]="whereData.objectWhere ? whereData.objectWhere : ''"
                >
                  <mat-option>None</mat-option>
                  <mat-option
                    *ngFor="let object of objectKeyList"
                    [value]="object"
                  >
                    {{ object }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4 filterCol">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCFields">Selected Attributes</mat-label>
                <mat-select
                  [(ngModel)]="whereData.fieldsWhere"
                  (selectionChange)="attrbuteSelection($event)"
                  [title]="whereData.fieldsWhere ? whereData.fieldsWhere : ''"
                  formControlName="fieldsWhere"
                >
                  <mat-option>None</mat-option>
                  <mat-option
                    *ngFor="let attribute of attriburteKeyList"
                    [value]="attribute"
                  >
                    {{ attribute }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4 filterCol">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                <mat-select
                  [(ngModel)]="whereData.conditionalOperatorWhere"
                  formControlName="conditionalOperatorWhere"
                  (selectionChange)="filterCondition($event)"
                  [title]="
                    whereData.conditionalOperatorWhere
                      ? whereData.conditionalOperatorWhere
                      : ''
                  "
                >
                  <mat-option>None</mat-option>
                  <mat-option
                    *ngFor="
                      let conditionalOperator of conditionalOperatorDataWhere
                    "
                    [(value)]="conditionalOperator.value"
                  >
                    {{ conditionalOperator.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-4 filterCol">
              <div *ngIf="betweenField">
                <div *ngIf="valueField">
                  <mat-form-field class="valueField" appearance="outline">
                    <mat-label i18n="@@RCEnterValue"
                      >Enter Start Value</mat-label
                    >
                    <input
                      matInput
                      type="text"
                      maxlength="50"
                      formControlName="enterValueWhere"
                      [(ngModel)]="whereData.enterValueBetweenStart"
                      [title]="
                        whereData.enterValueBetweenStart
                          ? whereData.enterValueBetweenStart
                          : ''
                      "
                    />
                  </mat-form-field>
                  <!-- <mat-form-field class="valueField" appearance="outline" style="margin-left: 1rem;">
                    <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                    <input matInput type="text" maxlength="50" formControlName="enterValueWhere"
                      [(ngModel)]="whereData.enterValueBetweenEnd" [title]="whereData.enterValueBetweenEnd ? whereData.enterValueBetweenEnd : '' ">
                  </mat-form-field> -->
                </div>
                <div *ngIf="dateChange">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERLastname"
                      >Select Start Date</mat-label
                    >
                    <input
                      matInput
                      [(ngModel)]="whereData.enterValueBetweenStart"
                      [matDatepicker]="whereDate1"
                      readonly
                      [max]="whereData.enterValueBetweenEnd"
                      formControlName="enterValueWhere"
                      [title]="
                        whereData.enterValueBetweenStart
                          ? dateFormatForTitle(whereData.enterValueBetweenStart)
                          : ''
                      "
                    />
                    <mat-datepicker-toggle matSuffix [for]="whereDate1">
                      <mat-icon matDatepickerToggleIcon
                        >keyboard_arrow_down</mat-icon
                      >
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle
                      class="clearIcon"
                      matSuffix
                      (click)="whereData.enterValueBetweenStart = null"
                    >
                      <mat-icon matDatepickerToggleIcon title="Clear"
                        >clear</mat-icon
                      >
                    </mat-datepicker-toggle>
                    <mat-datepicker #whereDate1></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div *ngIf="dateField">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMSTAFFMASTERLastname"
                    >Select Date</mat-label
                  >
                  <input
                    matInput
                    [(ngModel)]="whereData.enterValueWhereDate"
                    [matDatepicker]="whereDate"
                    readonly
                    formControlName="enterValueWhere"
                    [title]="
                      whereData.enterValueWhereDate
                        ? dateFormatForTitle(whereData.enterValueWhereDate)
                        : ''
                    "
                  />
                  <mat-datepicker-toggle matSuffix [for]="whereDate">
                    <mat-icon matDatepickerToggleIcon
                      >keyboard_arrow_down</mat-icon
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle
                    class="clearIcon"
                    matSuffix
                    (click)="clearDate(whereData)"
                  >
                    <mat-icon matDatepickerToggleIcon title="Clear"
                      >clear</mat-icon
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker #whereDate></mat-datepicker>
                </mat-form-field>
              </div>
              <div *ngIf="fieldChange">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="enterValueWhere"
                    [(ngModel)]="whereData.enterValueWhere"
                    [title]="
                      whereData.enterValueWhere ? whereData.enterValueWhere : ''
                    "
                  />
                </mat-form-field>
              </div>
              <div *ngIf="multiselect">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFields">Select Values</mat-label>

                  <input
                    matInput
                    type="text"
                    (click)="searchableDropdown()"
                    [(ngModel)]="whereData.multiSelect"
                    [(value)]="whereData.multiSelect"
                    formControlName="multiselect"
                    readonly
                  />
                  <!-- <mat-select [(ngModel)]="whereData.multiSelect" [title]="whereData.multiSelect ? whereData.multiSelect : '' "  multiple formControlName="multiselect">
                    <mat-option *ngFor="let field of multiSelectVaules" [(value)]="field.alias">
                      {{field.alias}}
                    </mat-option>
                  </mat-select> -->
                </mat-form-field>
              </div>
              <div *ngIf="maxORMinChange">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFields">Select Attributes</mat-label>

                  <input
                    matInput
                    type="text"
                    (click)="searchableSingleSelectForAtributies()"
                    [(ngModel)]="whereData.enterValueWhere"
                    [(value)]="whereData.enterValueWhere"
                    formControlName="maxORMin"
                    readonly
                  />
                  <!-- <mat-select [(ngModel)]="whereData.multiSelect" [title]="whereData.multiSelect ? whereData.multiSelect : '' "  multiple formControlName="multiselect">
                    <mat-option *ngFor="let field of multiSelectVaules" [(value)]="field.alias">
                      {{field.alias}}
                    </mat-option>
                  </mat-select> -->
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 filterCol" *ngIf="betweenField">
              <div>
                <div *ngIf="dateChange">
                  <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERLastname"
                      >Select End Date</mat-label
                    >
                    <input
                      matInput
                      [(ngModel)]="whereData.enterValueBetweenEnd"
                      [matDatepicker]="whereDate2"
                      readonly
                      [min]="whereData.enterValueBetweenStart"
                      formControlName="enterValueWhere"
                      [title]="
                        whereData.enterValueBetweenEnd
                          ? dateFormatForTitle(whereData.enterValueBetweenEnd)
                          : ''
                      "
                    />
                    <mat-datepicker-toggle matSuffix [for]="whereDate2">
                      <mat-icon matDatepickerToggleIcon
                        >keyboard_arrow_down</mat-icon
                      >
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle
                      class="clearIcon"
                      matSuffix
                      (click)="whereData.enterValueBetweenEnd = null"
                    >
                      <mat-icon matDatepickerToggleIcon title="Clear"
                        >clear</mat-icon
                      >
                    </mat-datepicker-toggle>
                    <mat-datepicker #whereDate2></mat-datepicker>
                  </mat-form-field>
                </div>
                <div *ngIf="valueField">
                  <mat-form-field class="valueField" appearance="outline">
                    <mat-label i18n="@@RCEnterValue">Enter End Value</mat-label>
                    <input
                      matInput
                      type="text"
                      maxlength="50"
                      formControlName="enterValueWhere"
                      [(ngModel)]="whereData.enterValueBetweenEnd"
                      [title]="
                        whereData.enterValueBetweenEnd
                          ? whereData.enterValueBetweenEnd
                          : ''
                      "
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                !dateField &&
                !dateChange &&
                !maxORMinChange &&
                whereData.conditionalOperatorWhere != 'CalculatedField' &&
                whereData.conditionalOperatorWhere !=
                  'CalculatedFieldWithFilter' &&
                whereData.conditionalOperatorWhere !=
                  'CalculatedFieldForReports'
              "
              class="col-lg-4 filterCol"
            >
              <!-- <div style="display: inline-flex;
                  justify-content: space-between; max-width: 100%;"> -->
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCConditionalOperators"
                  >Null Options</mat-label
                >
                <mat-select
                  [(ngModel)]="whereData.excludeOrShowNull"
                  formControlName="excludeOrShowNull"
                  [title]="
                    whereData.excludeOrShowNull
                      ? whereData.excludeOrShowNull
                      : ''
                  "
                >
                  <mat-option>None</mat-option>
                  <mat-option value="excludeNull">
                    Exclude Null Values
                  </mat-option>
                  <mat-option value="showOnlyNull">
                    Show Only Null Values
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <div style="width: 15%;text-align: end;">
                  <label (click)="addWhere()" style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;"><em class="fas fa-plus" style="color:
                      antiquewhite;font-size: large;" title="Add Filters"></em></label>
                </div> -->
              <!-- </div> -->
            </div>
            <div class="col-lg-4 filterCol" *ngIf="!maxORMinChange">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCConditionalOperators">Priority</mat-label>
                <mat-select
                  [(ngModel)]="whereData.priority"
                  formControlName="priority"
                  [title]="whereData.priority ? whereData.priority : ''"
                >
                  <mat-option value="preMax">Pre Max</mat-option>
                  <mat-option value="postMax">Post Max</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              *ngIf="
                maxORMinChange ||
                whereData.conditionalOperatorWhere == 'CalculatedField' ||
                whereData.conditionalOperatorWhere ==
                  'CalculatedFieldWithFilter'
              "
              class="col-lg-4 filterCol"
            >
              <mat-checkbox
                class="example-margin"
                [(ngModel)]="showInQuicksightVisuals"
                formControlName="showInQuicksightVisuals"
                style="width: 85%; padding: 5% 0; margin-right: 10%"
                >Show In Quicksight Visuals</mat-checkbox
              >
            </div>
            <div
              *ngIf="
                (maxORMinChange ||
                  whereData.conditionalOperatorWhere == 'CalculatedField' ||
                  whereData.conditionalOperatorWhere ==
                    'CalculatedFieldWithFilter') &&
                showInQuicksightVisuals
              "
              class="col-lg-4 filterCol"
            >
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCConditionalOperators"
                  >Show Calculated Field In</mat-label
                >
                <mat-select
                  [(ngModel)]="whereData.displayCalculatedFieldsIn"
                  formControlName="displayCalculatedFieldsIn"
                  [title]="
                    whereData.displayCalculatedFieldsIn
                      ? whereData.displayCalculatedFieldsIn
                      : ''
                  "
                >
                  <mat-option value="rows">Rows</mat-option>
                  <mat-option value="columns"> Columns </mat-option>
                  <mat-option value="values"> Values </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4 filterCol">
              <div
                style="
                  display: inline-flex;
                  justify-content: space-between;
                  max-width: 100%;
                "
              >
                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="hideInVisuals"
                  formControlName="hideInVisuals"
                  (change)="onHideVisuals($event)"
                  style="width: 85%; padding: 0; margin-right: 10%"
                  >Hide Filter</mat-checkbox
                >

                <mat-checkbox
                  class="example-margin"
                  [(ngModel)]="mandatoryFilter"
                  formControlName="mandatoryFilter"
                  (change)="onMandatoryFilter($event)"
                  style="width: 85%; padding: 0; margin-right: 10%"
                  >Mandatory</mat-checkbox
                >
                <div
                  style="
                    width: 15%;
                    text-align: end;
                    margin-left: 10px !important;
                  "
                >
                  <label
                    (click)="addWhere()"
                    style="
                      margin-top: 6px;
                      background: green;
                      margin-bottom: auto;
                      padding: 2px 5px 0px 5px;
                      border-radius: 15px;
                    "
                    ><em
                      class="fas fa-plus"
                      style="color: antiquewhite; font-size: large"
                      title="Add Filters"
                    ></em
                  ></label>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-1 filterCol">
              <div *ngIf="!betweenField && !scheduleRange">
                <label (click)="addWhere()" style="margin-top: 6px;
                  background: green;
                  margin-bottom: auto;
                  padding: 2px 5px 0px 5px;
                  border-radius: 15px;"><em class="fas fa-plus" style="color:
                    antiquewhite;font-size: large;" title="Add Filters"></em></label>
              </div>
            </div> -->
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg">
    <div class="container" style="text-align: center; margin-left: 25px">
      <div class="row topRowMargins" style="margin-top: -35px">
        <div class="col-lg-3"></div>
        <div class="col-lg-5"></div>
        <div class="col-lg-2">
          <button
            i18n="@@TMRunButton"
            type="button"
            (click)="createreport()"
            [style.background-color]="buttonColor"
            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.5rem; font-size: 0.85rem; width: 100%"
          >
            {{ buttonName }}
          </button>
        </div>
        <div class="col-lg-2">
          <button
            i18n="@@TMRunButton"
            type="button"
            (click)="cancel()"
            [style.border-color]="buttonColor"
            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding: 0.3rem 1.6rem; font-size: 0.85rem; width: 100%"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
